import type { FaireThemeEntity } from "../../entity_types/theme";

export const discovery_theme_vintage_inspired: FaireThemeEntity = {
  token: "discovery_theme_vintage-inspired",
  type: "theme",
  retailerToken: "r_discovery",
  name: "Vintage-Inspired Finds",
  description: "Retro charm with a modern twist",
  bgColor: "#E8D8C8",
  productTokens: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
